import styled from 'styled-components';

import { Flex } from '../Flex';

export const StyledBadge = styled(Flex)``;
